import makeStyles from "@mui/styles/makeStyles";

export const useTableCellStyles = makeStyles((theme) => ({
  sizeSmall: {
    padding: "4px 12px",
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    "&:last-child": {
      paddingRight: 8,
    },
    "&.MuiTableCell-head": {
      height: 36,
    },
    "&.MuiTableCell-body": {
      height: 44,
    },
  },
}));

export const useStyles = makeStyles((theme) => ({
  borderRight: {
    borderRight: `1px solid ${theme.palette.grey[200]}`,
  },
}));
